<template>
  <div id="hres35u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres35uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="approveEvent"
            :approveRowBool="true" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang" />

    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="approve" data-target="#hres35u-popup-approve"><i class="fa fa-list-alt"></i> {{ btn_approve }}</button>
    </div>
    
    <popup-approve :labels="labels[dash.nowLang]"
            :nowLang="dash.nowLang"
            :labelsButton="dash.button[dash.nowLang]"
            :indexSelected="indexSelected"
            :arrCodmov="dropdowns.codmov"
            :postHres35uSendApprove="postHres35uSendApprove" 
            :codappr="codempid"
            :descCodappr="dash.currentUser.username[dash.nowLang]" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres35u/mutation-types'
import detail from 'components/hres35u/detail'
import popupApprove from 'components/hres35u/popupApprove'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  name: 'hres35u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Approve'
    }
  },
  created () {
    this.receivedHres35uColumnsLabels()
    this.receivedHres35uIndex()
    // this.receivedHres35uApprove()
    this.receivedHres35uDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES35U_INDEX_DISP,
      detailDisp: types.GET_HRES35U_DETAIL_DISP,
      columns: types.GET_HRES35U_COLUMNS,
      labels: types.GET_HRES35U_LABELS,
      index: types.GET_HRES35U_INDEX,
      indexSelected: types.GET_HRES35U_INDEX_SELECTED,
      detail: types.GET_HRES35U_DETAIL,
      dropdowns: types.GET_HRES35U_DROPDOWNS
    })
  },
  methods: {
    pageDetail (event) {
      let detailParams = this.indexSelected
      this.receivedHres35uDetail(detailParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    approveEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgStaappr !== 'undefined' && dataRow.flgStaappr !== 'P' && dataRow.flgStaappr.trim() !== ''
      })
      if (dataRowsFiltered.length > 0) {
        this.setIndexSelected(dataRowsFiltered[0])
        this.$refs.approve.click()
      } else {
        swal({
          title: 'ยืนยันการทำรายการ',
          text: 'รายการยังไม่ถูกเลือก'
        })
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES35U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES35U_PAGE,
      receivedHres35uColumnsLabels: types.RECEIVED_HRES35U_COLUMNS_LABELS,
      receivedHres35uIndex: types.RECEIVED_HRES35U_INDEX,
      receivedHres35uDetail: types.RECEIVED_HRES35U_DETAIL,
      postHres35uSendApprove: types.POST_HRES35U_SEND_APPROVE,
      receivedHres35uDropdowns: types.RECEIVED_HRES35U_DROPDOWNS
    })
  },
  components: {
    detail,
    popupApprove
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?192e1841